<template>
  <div v-if="!hasNoProducts" :id="'category_' + category.entity_id " class="mb15 pt30 mt-20" v-intersect="intersectConfig">
    <div class="container">
      <div class="row middle-sm">
        <h2 class="col-xs-12 category-title mb10 mt0 align-center light" :ref="category.url_key">
          <router-link :to="categoryLink(category)" class="cat-cla view-more-categ link">
            {{ category.name }}
          </router-link>
        </h2>
      </div>
    </div>
    <div class="container">
      <div class="row m0 pt15">
        <div class="col-md-12 px10 border-box products-list">
          <product-listing v-if="products.length"
                           :columns="columns"
                           :products="products"
                           :available-products="category.product_count"
                           :category="category"
                           :categoryIndex="categoryIndex"
          />
          <bounce-loader v-else />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import ProductListing from 'theme/components/theme/blocks/Home/ProductsListing.vue'
  import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
  import BounceLoader from 'theme/components/theme/blocks/Home/Preloaders/BounceLoader'
  import { isServer } from '@vue-storefront/core/helpers'
  import intersect from 'theme/directives/intersect'
  import { curatedProducts } from '@vue-storefront/core/lib/catalogSearch'

  export default {
    name: 'Grid',
    directives: {
      intersect
    },
    components: {
      ProductListing,
      BounceLoader
    },
    data () {
      return {
        scrollToSection: false,
        products: [],
        attemptedLoad: false
      }
    },
    computed: {
      ...mapGetters({
        currentPartnerCode: 'partners/getCurrentPartnerCode',
        allProducts: 'product/list'
      }),
      currentLocationCode () {
        return this.$route.params.locationCode
      },
      columns () {
        if (isServer) {
          return 1
        }
        if (window.innerWidth > 991) {
          return 3
        } else if (window.innerWidth >= 576 && window.innerWidth <= 991) {
          return 2
        } else if (window.innerWidth < 576) {
          return 1
        }
      },
      intersectConfig () {
        if (this.hasNoProducts || this.category.product_count <= this.products.length) {
          return false
        }
        return {
          margin: '50px',
          threshold: 0.1,
          onIntersect: this.updateProducts
        }
      },
      // category.product_count can be stale/wrong (computed independently of the actual
      // catalog), so "empty" has to be confirmed by an actual fetch resolving with nothing,
      // not assumed from the count - otherwise a real fetch might still find products later.
      hasNoProducts () {
        return this.attemptedLoad && this.products.length === 0
      }
    },
    props: {
      category: {
        type: Object,
        required: true
      },
      categoryIndex: {
        type: Number
      }
    },
    created () {
      this.products = this.allProducts.filter(product => product.category_ids.includes(this.category.entity_id))
      let { query } = this.$route
      if (query && query['section']) {
        this.scrollToSection = query['section']
      }
    },
    updated () {
       if (this.scrollToSection) {
         this.scrollTo(this.scrollToSection)
         this.scrollToSection = false
       }
    },
    methods: {
      ...mapActions({
        loadProducts: 'product/list'
      }),

      async updateProducts (size = 12, start = 0) {
        if (this.products.length) {
          start = this.products.length
          size = this.category.product_count - this.products.length
        }
        let products = await this.loadProducts({
          semanticFetch: () => curatedProducts({ categoryIds: [this.category.entity_id], start, size })
        })
        this.products.push(...products.items)
        this.attemptedLoad = true
      },
      categoryLink (category) {
        return `/${this.currentLocationCode}/${this.currentPartnerCode}${formatCategoryLink(category)}`
      },
      scrollTo(section) {
        if (this.$refs[section]) {
          this.$refs[section].scrollIntoView({ behavior: 'smooth' })
        }
      }
    }
  }
</script>
<style>
  .view-more-categ{
    font-size: 21px;
  }
</style>
<style scoped>
.mt-20{
  margin-top: -20px;
}
.link:hover {
  text-decoration: underline;
}
</style>
